
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/overview",
      function () {
        return require("private-next-pages/agents/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/overview"])
      });
    }
  